import { useCallback, useMemo } from 'react';

import { useIsLargerThanWide } from '../../styles/hooks/media';
import { useCoreDispatch } from '../CoreStore';
import { useGameStateSlice } from '../slices/game/selectors';
import { gameStateActions } from '../slices/game/slice';
import { headerActions } from '../slices/header/slice';

export const useDrawerHidden = (): boolean => {
  const hideUI = useGameStateSlice.hideUI();
  const desktop = useIsLargerThanWide();

  return useMemo(() => {
    return !desktop && hideUI;
  }, [hideUI, desktop]);
};

export const useActiveDialogCleaner = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const hideDrawer = useDrawerHidden();

  return useCallback((): void => {
    // Close Lobby
    dispatch(headerActions.setMiniLobbyOpen(false));
    // CLose Modals For Desktop (History, Help, Settings)
    dispatch(headerActions.setOpenedModal(null));
    // CLose Modals For Mobile (History, Help, Settings)
    dispatch(headerActions.setNavRoute([]));
    // Close bottom sheet modals like Autoplay or Statistics
    dispatch(headerActions.setOpenedBottomSheetModal(null));

    if (hideDrawer) {
      dispatch(headerActions.setOpenedDrawer(null));
    }

    // Disable Hide UI functionality
    dispatch(gameStateActions.setHideUI(false));
  }, [dispatch, hideDrawer]);
};
